import { OFFICE_TIME_ZONE } from './welcome-weather.js';

const clockFormat = new Intl.DateTimeFormat('en-GB', {
  hour: '2-digit',
  minute: '2-digit',
  second: '2-digit',
  hourCycle: 'h23',
  timeZone: OFFICE_TIME_ZONE,
});

/** "HH:MM:SS" on the office's wall clock (Europe/Stockholm), so daylight saving is handled for us. */
export function formatOfficeClock(date: Date): string {
  const parts = clockFormat.formatToParts(date);
  const part = (type: Intl.DateTimeFormatPartTypes) =>
    parts.find((p) => p.type === type)?.value ?? '00';
  return `${part('hour')}:${part('minute')}:${part('second')}`;
}

const timestampFormat = new Intl.DateTimeFormat('en-GB', {
  year: 'numeric',
  month: '2-digit',
  day: '2-digit',
  hour: '2-digit',
  minute: '2-digit',
  second: '2-digit',
  hourCycle: 'h23',
  timeZone: OFFICE_TIME_ZONE,
});

/** "yyyy-mm-dd HH:MM:SS" in office time (Europe/Stockholm), used to stamp chat messages. */
export function formatChatTimestamp(date: Date): string {
  const parts = timestampFormat.formatToParts(date);
  const part = (type: Intl.DateTimeFormatPartTypes) =>
    parts.find((p) => p.type === type)?.value ?? '00';
  return `${part('year')}-${part('month')}-${part('day')} ${part('hour')}:${part('minute')}:${part('second')}`;
}

/** Milliseconds until the next whole second, so the clock ticks over on the second. */
export function msUntilNextSecond(date: Date): number {
  return 1000 - (date.getTime() % 1000);
}
